import React from "react";
import OrderListComponent from "../../components/manager/leads/OrderListComponent";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import BackUpOrderListComponent from "../../components/manager/leads/BackupOrderListComponent";

const OrderlistSA = ({backup}) => {
  return (
    <DashboardLayout>
      {
        backup?
        <BackUpOrderListComponent/>:
        <OrderListComponent/>}
    </DashboardLayout>
  );
};

export default OrderlistSA;
